import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Row } from '@tanstack/react-table';
import { FormattedMessage, useIntl } from 'react-intl';

import { Button } from 'src/registry/ui/Button';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from 'src/registry/ui/Tooltip';
import { generalMessages } from 'src/registry/utils/messages';
import { ICON_MAP } from 'src/utils/constants';
import { BankAccount } from 'src/features/billingEntityBankAccounts/utils/types';
import DeleteBillingEntityBankAccountFormModal from 'src/features/billingEntityBankAccounts/components/forms/DeleteBillingEntityBankAccountFormModal';
import UpdateBillingEntityBankAccountFormModal from '../forms/UpdateBillingEntityBankAccountFormModal';
import { moneyAccountsMessages } from 'src/features/moneyAccounts/utils/messages';

type CellBillingEntityBankAccountActionsProps = {
    row: Row<BankAccount>;
};

export default function CellBillingEntityBankAccountActions({ row }: CellBillingEntityBankAccountActionsProps) {
    const { formatMessage } = useIntl();

    return (
        <div className="flex w-full justify-end gap-1">
            <TooltipProvider>
                <Tooltip>
                    <UpdateBillingEntityBankAccountFormModal
                        semantics={{ entryName: formatMessage(moneyAccountsMessages.account).toLowerCase() }}
                        selectedBankAccount={row.original}
                    >
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.EDIT} />
                            </Button>
                        </TooltipTrigger>
                    </UpdateBillingEntityBankAccountFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.edit} />
                    </TooltipContent>
                </Tooltip>
                <Tooltip>
                    <DeleteBillingEntityBankAccountFormModal selectedBankAccount={row.original}>
                        <TooltipTrigger asChild>
                            <Button size="icon" variant="link" className="cursor-pointer hover:bg-gray-100">
                                <FontAwesomeIcon icon={ICON_MAP.DELETE} />
                            </Button>
                        </TooltipTrigger>
                    </DeleteBillingEntityBankAccountFormModal>
                    <TooltipContent>
                        <FormattedMessage {...generalMessages.delete} />
                    </TooltipContent>
                </Tooltip>
            </TooltipProvider>
        </div>
    );
}
